import { type ExamDefinitionDto, useExamDefinition } from "@repo/data-store";
import { createFileRoute } from "@tanstack/react-router";
import { CatalogDefinition, ExamRead } from "@/features/catalog";
import { useDefinitionChangePoints, useDefinitionView } from "@/features/catalog/hooks/use-definition-as-of";
import { asOfSearchSchema } from "@/features/catalog/lib/as-of-search";
import { examDefinitionUrlFromRouteId } from "@/features/catalog/lib/exam-definition-route";
import { canWriteExamDefinitions } from "@/features/catalog/lib/exam-permissions";

export const Route = createFileRoute("/catalog/exams/$examId")({
  component: ExamDetailComponent,
  validateSearch: asOfSearchSchema,
});

function ExamDetailComponent() {
  const { examId } = Route.useParams();
  const { asOf } = Route.useSearch();
  const { permissions } = Route.useRouteContext();
  const definitionUrl = examDefinitionUrlFromRouteId(examId);
  const live = useExamDefinition(asOf ? undefined : definitionUrl);
  const view = useDefinitionView<ExamDefinitionDto>(definitionUrl, asOf, live);
  const { changePoints } = useDefinitionChangePoints(definitionUrl);

  if (view.isPending) return <CatalogDefinition.Pending />;
  if (!view.definition) {
    return <CatalogDefinition.NotFound label="Exam" backTo="/catalog/exams" backLabel="Back to exams" />;
  }

  return (
    <ExamRead
      key={`${examId}|${asOf ?? "latest"}`}
      definition={view.definition}
      asOf={asOf}
      changePoints={changePoints}
      canEdit={!view.isPast && canWriteExamDefinitions(permissions)}
    />
  );
}
